/* global client */

import {urlParamsToJSON} from './util.js';
import {renderInfo} from './renderInfo.js';
import {changePage, getCurrentPage} from './changePage.js';
import {unByKey} from '../node_modules/ol/Observable.js';

/*
  Discussion 2018-08-13:

  * pop is a real problem because it calls applyUrlArgs() which may call functions that push,
  * but we do not want anything pushed during a pop. And some of the functions that call push
  * may fire asynchronously after pop has completed. Examples are 'moveend' and 'info' but there
  * may be others.
  *
  * 'moveend' can be dealt with by putting a 'movestart' on the map at the beginning of a pop
  *    that sets the 'pendingRedraw' flag and then clearing it on the next 'moveend'.
  * 'info' needs something similar. See 'pendingInfo' in applyUrlArgs()
  * changing layers may or may not fire a moveend or make a new request to mapserv
  *
  * So currently doing a setTimeout() which sets shouldPush=true after 300ms, which seems an awful kluge.

  Initialization:

  * The History constructor below calls applyUrlArgs() to read any external params
      Using "firstRun" to only process external params during initialization
  * In rwg.init map.on('moveend') calls push() so want to do history.replaceState()
      rather than history.pusevent.state.page !== hState(). Using "initialized" to accoplish this
    CHANGED THIS - map.on('moveend') is added in this constructor and AFTER initial call to applyUrlArgs()
      so maybe initialized and replaceState could go away?

  TO DO :

  * 'legend' is a parameter to constructor so that layers can be added but seems like
     calling appropriate rwg.layers.* functions would be cleaner
  * add expand legend node via query string e.g. "rocksprings"
  * deal with all possible args, see below
 */

// constructor
export default function(map, legend) {
  // rwg.history = [];  // for debugging only!

  var shouldPush = true;  // do not update the URL when the view was changed in the 'popstate' handler
  var initialized = false;  // do window.history.replaceState() first time out
  var pendingRedraw = false;  // true between movestart and moveend


  /* private function called by constructor & pop()
   *
   * As of rwg-ol3 version, I prefer to pass parameters via the hash (#) rather than
   * the query string (?). Hash is for parameters processed by the browser,
   * query string is for parameters processed by the server. However 'idnum' is
   * a supported query string parameter in the ol3 mobile version.
   */
  function applyUrlArgs(firstRun) {
    var
      url,
      zoom2it = false,
      pidn = null,
      filter = null,
      // qlayer = null,
      args = urlParamsToJSON();

    // console.log('applyUrlArgs');
    var movestart = map.on('movestart',  function(evt) {  // eslint-disable-line no-unused-vars
      pendingRedraw = true;
      // console.log('movestart pendingRedraw:', pendingRedraw, evt);
    });


    /*
     * + idnum
     * + pidn (broken in live responsive version!)
     * + apn DOES zoom to parcel (hyphenated or not)  test w/ view and examples from log http://w2/te/dev#apn=22-44-18-17-4-03-004   http://w2/te/dev#apn=441817403004
     * + view
     * - qlayer  (2093)   w2/tetonwy/mapserver/map?zoom=9.169630572235487&lat=1468909.3475&lon=2516023.3825&layers=BTF&mslayers=placelabels ownership Roads water state_fed a2013&filter=(pidn in(%2722-42-14-02-1-00-002%27))&qlayer=ownershipq
     * + tab = search | asearch | cemetery
     * + zoom -    (177)
     * + lon & lat (177)
     * + mapext    (26 all in tetonwy, not working in responsive)
     * + mslayers  (230)
     * - addLayers  (0)

     * + lyrs
     * + zcr
     * + filter

     * - layers   layers=ownass   apparently only in fremontid which is OpenLayers 2 (for Google)
     */

    // firstRun handles args that would only come externally
    if (firstRun) {
      /*
      // 'idnum' needs some review. The mobile version calls listJSON.php
      // infoTool.php might be useable here. Would have to find the geom,
      // which is not at a fixed location in the result.


      $grep -r --include *.php --exclude-dir raster* idNumWhere .
      ./johnson/htdocs/mapserver/tabList.php:    function idNumWhere ($id)
      ./sweetwater/htdocs/mapserver/tabList.php: function idNumWhere ($id)
      ./park/htdocs/mapserver/tabList.php:       function idNumWhere ($id)
      ./bighorn/htdocs/mapserver/tabList.php:    function idNumWhere ($id)
      ./converse/htdocs/mapserver/tabList.php:   function idNumWhere ($id)
      ./sheridan/htdocs/mapserver/tabList.php:   function idNumWhere ($id) // R0007109
      ./fremontwy/htdocs/mapserver/tabList.php:  function idNumWhere ($id)
      ./uinta/htdocs/mapserver/tabList.php:      function idNumWhere ($id)
      ./washakie/htdocs/mapserver/tabList.php:   function idNumWhere ($id)
      ./hotsprings/htdocs/mapserver/tabList.php: function idNumWhere ($id)
      ./fremontid/htdocs/mapserver/tabList.php:  function idNumWhere ($id)

      ./sublette/htdocs/mapserver/tabList.php:   function idNumWhere ($id)
      ./sublette/htdocs/mapserver/mobile-app/listJSON.php:   WHERE ' . idNumWhere($_REQUEST['idnum']);  // idNumWhere() is in site_var.php. County specific code to parse idnum as pidn, tax_id or accountno

      ./tetonwy/htdocs/mapserver/etc/site_var.php: function idNumWhere ($id)
      ./albany/htdocs/mapserver/etc/site_var.php:  function idNumWhere($id)
      ./bighorn/htdocs/mapserver/etc/site_var.php: function idNumWhere($id)
      */

      if (args.idnum) {
        url = rwg.config.search_url || 'listJSON.php';
        url += '?idnum=' + args.idnum;
        rwg.ajax(url, { success: function(response) {
          if (response) {
            var results = JSON.parse(response);
            // results.forEach(function(rec) {  // forEach is pretty dumb here since we can only map one feature
            //   rwg.mapFeatures(rec[3]);
            // });
            rwg.mapFeatures(results[0][3], true);
            rwg.mapFeatures(results[0][4], true);
          }
        }});
      }

      if (args.pidn || args.apn ) {  // apn is only used in Town of Jackson's TrackIt permit database. It is a PIDN beginning w/ 22 but no hyphens. 'view' is not set when coming from TrackIt
        // hyphenatePIDN() is defined for Teton & Sweetwater Counites becasue they hyphenate their PIDNs
        if (typeof rwg.config.hyphenatePIDN === 'function' /* && rwg.config.hasOwnProperty('hyphenatePIDN') */ ) {
          pidn = rwg.config.hyphenatePIDN(args.pidn || args.apn);
        } else {
          pidn = args.pidn;
        }
        // 'view' is not set when coming from TrackIt
        if (args.view || args.apn) {  // args.view could be used to set different layers for planning, clerk, assessor, etc. but currently just using viewLayers in all cases
          if (typeof rwg.config.viewLayers === 'string') {
            legend.uncheckAll();
            rwg.layers.addLayers(rwg.config.viewLayers);
          }
        }
        zoom2it = true;
      }
      // if (args.qlayer) { qlayer = args.qlayer; }
      if (args.tab) {
        if (args.tab === 'search') {
          rwg.tabs.activate('top-search')
        } else if (args.tab === 'asearch') {
          rwg.tabs.activate('top-search')
          rwg.tabs.activate('srch-adv')
        }
      }
      /*
      if (args.zoom) { // 2023-10-01 I don't think zoom is used anymore
        map.getView().setZoom(parseFloat(args.zoom)); // in TC ol3 zoom 0-11, OpenLayers 2 zoom 0-15
        zoom2it = false;
      }
      if (args.lon && args.lat) { // 2023-10-01 I don't think lon, lat are still used
        map.getView().setCenter([ parseFloat(args.lon), parseFloat(args.lat) ]);
      }
      */
      if (args.mapext) { // cpc & fremontid still use mapext
        map.getView().fit(args.mapext.split(' ').map(Number), map.getSize()); // <- converts the strings to array of numbers, see: Array.prototype.map and Number: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number
      }
      if (args.mslayers) {  // set layers, ignoring default layers
        // map.getLayerByTitle('lyrBase').getSource().getParams().LAYERS = args.mslayers.replace(' ', ',');
        // legend.collapseAll();
        legend.uncheckAll();
        args.mslayers.split(' ').forEach( function(lyr) {
          legend.check(lyr);
        });
        // rwg.layers.addLayers(args.mslayers);  // WHAT'S THIS DO? IS IT NECESSARY?
      }
      if (args.addLayers) { rwg.layers.addLayers(args.addLayers); }  // adds to layers
    } // firstRun

    if (args.lyrs) {  // set layers, ignoring default layers
      // below requires the addition of Array.prototype.equals()
      // only thing it gains is pendingRedraw because ol is smart enough not to
      // redraw if layers haven't changed even tho we've called legend on/off a bunch
      // if (!args.lyrs.split(',').equals(rwg.layers.getActiveDrawLayers())) {
      //   pendingRedraw = true;
      legend.uncheckAll();
      args.lyrs.split(',').forEach( function(lyr) {
        legend.check(lyr);
      });
    }
    if (args.zcr) {  // Zoom Center Rotation
      let zcr = args.zcr.split('/').map(Number);  // cast strings to numbers
      let view = map.getView();
      view.setZoom(zcr[0]);
      view.setCenter([zcr[1], zcr[2]]);
      view.setRotation(zcr[3]);
      zoom2it = false;
    } else if (!rwg.config.olView.center && !rwg.config.olView.zoom) { // fit to extent if zoom & center not defined in config
      map.getView().fit(rwg.config.olView.extent)
    }
    if (args.filter) {
      filter = args.filter; // filter is processed below
    }
    if (pidn && !filter) {
      filter = "(pidn in('" + pidn + "'))"; // eslint-disable-line quotes
    }
    if (filter) {
      // pendingInfo = true; // filter will call county's info() which will call historyManager.push()
      rwg.filter = filter;
      url = rwg.config.info_url;
      // This does NOT cover all cases e.g. roads, subdivisions, conserv esmnts -  grep -r filter /gis/Wyoming/22_Teton/mapserv
      // if (qlayer) { url += '&qlayer=' + qlayer; }
      // url += '&layers=' + rwg.layers.getActiveInfoLayers();
      url += '&layers=ownership';
      url += '&filter=' + encodeURIComponent(filter);
      renderInfo(url, zoom2it, firstRun);
    } else if (rwg.filter) {  // there's no filter in url args but rwg.filter is set so clear it
      rwg.filter = '';
      document.getElementById('infotool').innerHTML = '';   // clear the info tool easy way
      map.getLayerByTitle('lyrVector').getSource().clear();
    }

    unByKey(movestart);
  } // applyUrlArgs


  function push(evt) {
    var evtType = null;
    if (evt) {
      evtType = evt.type || evt;  // evt may be an object from ol, or a string from dlegend, or undefined from info
    }
    // console.log('push', shouldPush, 'evt:', evtType /*, 'this:', this */);

    // various things might call a history.push() but if we're currently within a history.pop() we do NOT want to push
    if (!shouldPush) return;

    // moveend will always call push()
    if (evtType === 'moveend' && pendingRedraw) {
      pendingRedraw = false;
      return;
    }

    var view = map.getView();
    var hash = '#zcr=' +  //   zcr = Zoom, Center, Rotation
      view.getZoom() + '/' +
      view.getCenter().join('/') + '/' +
      view.getRotation() +
      '&lyrs=' + rwg.layers.getActiveDrawLayers().toString();
    if (rwg.filter) hash += '&filter=' + encodeURIComponent(rwg.filter);
    if (typeof client === 'string') hash += '&client=' + client;  // for cpc
    var url = window.location.origin + window.location.pathname + hash;

    if (rwg.layout.get() === 'paged' && history.state) {
      history.state.page = getCurrentPage().id;
    }

    if (!initialized) {
      window.history.replaceState(history.state, null, url);
      // console.log('History.replaceState', 'browser:', history.length, history.state);
      initialized = true;
    } else {
      window.history.pushState(history.state, null, url);

      // console.trace();
      // rwg.history.push(history.state);
      // console.log('History.push rwg:', rwg.history.length, JSON.stringify(rwg.history),  'browser:', history.length, history.state);
      // rwg.history.forEach(e => console.log(e))
    }
  }


  function pop(evt) {
    var evtPage = '';
    if (evt.state && evt.state.page) {
      evtPage = evt.state.page;
    }
    shouldPush = false;
    // console.log('pop rwg:', rwg.history.pop(), rwg.history.length, JSON.stringify(rwg.history),  'browser:', history.length, history.state);
    // rwg.history.forEach(e => console.log(e))
    // if we're in paged-mode see if this is just a page change,
    // if so process the history.state, ignore the location.hash

    if (rwg.layout.get() === 'paged' &&
        evtPage !== getCurrentPage().id &&
        evtPage !== 'layerspage' ) { // never go back to the layers page
      changePage(evtPage, false);
    } else if (evtPage &&       // if (rwg.config.tcwp)
        document.getElementById(evtPage).parentElement.id === 'tcwp-elements' &&
        evtPage !== getCurrentPage().id) {  // this probably isn't necessary
      window.changePageOrTab(evtPage, false);
    } else { // not page change so process the location.hash args, ignore the history.state
      applyUrlArgs(false);
      // console.log('pop applied args' /*, rwg.history.pop(), rwg.history.length, JSON.stringify(rwg.history),  'browser:', history.length, history.state */ );
    }

    setTimeout(function() {
      // we don't know if this "pop" evt will trigger a map redraw, but
      // this keeps "shouldPush=false" until 'moveend' has (hopefully) finished
      shouldPush = true;
    }, 300);

  }

  // constructor stuff:
  applyUrlArgs(true); // called during instantiation
  map.on('moveend', push);
  window.addEventListener('popstate', pop);


  return {
    // pop: pop,
    push: push
  };

}
